export const getCredentials = ()=> {
  const environment = process.env.REACT_APP_ENV;
  
  if (environment === "DEV") {
    return {
      username: process.env.REACT_APP_DEV_USERNAME,
      password: process.env.REACT_APP_DEV_PASSWORD,
    };
  }
  return {};
}






